import React, { useState, useEffect } from "react";
import PageTitle from "../../layout/PageTitle";
import { toast } from "react-toastify";
import { validatePhoneNumber } from "../../utils/common";
import { loadRazorpay } from "../../services/RazorPay";
import { createAppointment } from "../../apis/AppointmentApi.js";
import { Gender, SlotTime } from "../../constants/AppointmentConstant.js";
import { getAllSlots } from "../../apis/SlotApi.js";
import Loader from "../../common/Loader.js";

function Appointment({ setTab }) {
  const today = new Date().toISOString().split("T")[0];

  const intialData = {
    name: "",
    phone: "",
    age: "",
    gender: "",
    date: today,
    slotTime: "",
    email: "",
    city: "",
    notes: "",
  };
  const [formData, setFormData] = useState(intialData);
  const [loading, setLoading] = useState(false);
  const [availableSlots, setAvailableSlots] = useState([]);
  const [allSlots, setAllSlots] = useState([]);

  const slotTimes = Object.values(SlotTime);
  const genderData = Object.values(Gender);

  const getDayNumber = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDay(); // 1 for Monday, 7 for Sunday etc.
    if (day === 0) return 7; // By default for sunday it returns 0 and we want 7 for sunday
    return day;
  };

  const updateAvailableSlots = (date) => {
    const dayNumber = getDayNumber(date);
    const data = allSlots.filter((slot) => slot.day === dayNumber);
    setAvailableSlots(data?.[0]?.availableSlots || []);
  };

  const fetchSlots = async () => {
    try {
      setLoading(true);
      const response = await getAllSlots();

      if (response && Array.isArray(response)) {
        setAllSlots(response);
        // Set initial slots for today
        updateAvailableSlots(today);
      } else {
        console.error("Invalid slots response:", response);
        toast.error("Failed to fetch available slots");
      }
    } catch (error) {
      console.error("Error fetching slots:", error);
      toast.error("Failed to fetch ddd available slots");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "date") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        slotTime: "", // Reset slot time when date changes
      }));
      updateAvailableSlots(value);
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const validateForm = () => {
    const { name, phone, age, gender, date, slotTime } = formData;
    let hasError = false;
    if (!name) {
      hasError = true;
      toast.error("Please enter name!");
    } else if (!validatePhoneNumber(phone)) {
      hasError = true;
      toast.error("Please enter a valid phone number!");
    } else if (!age) {
      hasError = true;
      toast.error("Please enter age!");
    } else if (!gender) {
      hasError = true;
      toast.error("Please select gender!");
    } else if (!date) {
      hasError = true;
      toast.error("Please enter the appointment date!");
    } else if (!slotTime) {
      hasError = true;
      toast.error("Please select slot!");
    }
    return hasError;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate the form fields
    const hasError = validateForm();
    if (!hasError) {
      try {
        setLoading(true);
        const result = await createAppointment(formData);
        if (result) {
          loadRazorpay(result, formData, setFormData, intialData, setLoading);
        } else {
          setLoading(false);
          toast.error("Appointment booking failed due to a technical error.");
        }
      } catch (error) {
        setLoading(false);
        toast.error("Something went wrong");
      }
    }
  };

  useEffect(() => {
    setTab("appointment");
    fetchSlots(); // Fetch slots on component mount
  }, [setTab]);

  // Update slots when allSlots changes
  useEffect(() => {
    if (allSlots.length > 0) {
      updateAvailableSlots(formData.date);
    }
  }, [allSlots]);

  const isSlotAvailable = (slotTime) => {
    return availableSlots.includes(slotTime);
  };

  return (
    <>
      {loading ? (
        <Loader showLoading />
      ) : (
        <>
          <PageTitle page="Appointment" setTab={setTab} />
          <div className="site-main">
            <section className="conatact-section clearfix">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="ttm-bgcolor-grey text-center p-40 padding_top35 res-991-p-15 res-991-padding_top30 res-991-padding_bottom30">
                      <h2 className="fs-26">Book An Appointment</h2>
                      <p>Please enter your details, to make an appointment.</p>
                      <p style={{ color: "#FFA500" }}>
                        <strong>Note: </strong>The patients will be attended to
                        on a first-come, first-served basis.
                      </p>
                      <div className="padding_top30">
                        <div
                          id="request_qoute_form"
                          className="request_qoute_form wrap-form clearfix"
                          onSubmit={handleSubmit}
                        >
                          <div className="row ttm-boxes-spacing-20px">
                            <div className="col-md-6">
                              <label
                                className="left-align-label"
                                htmlFor="name"
                              >
                                Patient Name
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <span className="text-input">
                                <input
                                  id="name"
                                  name="name"
                                  type="text"
                                  value={formData.name}
                                  placeholder="Enter your name"
                                  required
                                  onChange={handleInputChange}
                                />
                              </span>
                            </div>

                            <div className="col-md-6">
                              <label
                                className="left-align-label"
                                htmlFor="phone"
                              >
                                Phone Number
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <span className="text-input">
                                <input
                                  id="phone"
                                  name="phone"
                                  type="number"
                                  value={formData.phone}
                                  placeholder="Enter your phone number"
                                  required
                                  onChange={handleInputChange}
                                />
                              </span>
                            </div>

                            <div className="col-md-6">
                              <label className="left-align-label" htmlFor="age">
                                Age<span style={{ color: "red" }}>*</span>
                              </label>
                              <span className="text-input">
                                <input
                                  id="age"
                                  name="age"
                                  type="number"
                                  value={formData.age}
                                  placeholder="Enter your age"
                                  required
                                  onChange={handleInputChange}
                                />
                              </span>
                            </div>

                            <div className="col-md-6">
                              <label
                                className="left-align-label"
                                htmlFor="gender"
                              >
                                Gender<span style={{ color: "red" }}>*</span>
                              </label>
                              <span className="text-input">
                                <select
                                  id="gender"
                                  name="gender"
                                  value={formData.gender}
                                  onChange={handleInputChange}
                                  required
                                >
                                  <option value="">Select Gender</option>
                                  {genderData.map((item) => (
                                    <option key={item} value={item}>
                                      {item}
                                    </option>
                                  ))}
                                </select>
                              </span>
                            </div>

                            <div className="col-md-6">
                              <label
                                className="left-align-label"
                                htmlFor="date"
                              >
                                Appointment Date
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <span className="text-input">
                                <input
                                  id="date"
                                  name="date"
                                  type="date"
                                  value={formData.date}
                                  required
                                  onChange={handleInputChange}
                                  min={today}
                                />
                              </span>
                            </div>

                            <div className="col-md-6">
                              <label
                                className="left-align-label"
                                htmlFor="slotTime"
                              >
                                Slot Time<span style={{ color: "red" }}>*</span>
                              </label>
                              <span className="text-input">
                                <select
                                  id="slotTime"
                                  name="slotTime"
                                  value={formData.slotTime}
                                  onChange={handleInputChange}
                                  required
                                >
                                  <option value="">Select Slot</option>
                                  {slotTimes.map((time) => (
                                    <option
                                      key={time.value}
                                      value={time.value}
                                      disabled={!isSlotAvailable(time.value)}
                                      style={{
                                        color: isSlotAvailable(time.value)
                                          ? "inherit"
                                          : "#999",
                                        backgroundColor: isSlotAvailable(
                                          time.value
                                        )
                                          ? "inherit"
                                          : "#f5f5f5",
                                      }}
                                    >
                                      {time.title}{" "}
                                      {!isSlotAvailable(time.value) &&
                                        "(Not Available)"}
                                    </option>
                                  ))}
                                </select>
                              </span>
                            </div>

                            <div className="col-md-6">
                              <label
                                className="left-align-label"
                                htmlFor="email"
                              >
                                Email (Required to receive appointment details)
                              </label>
                              <span className="text-input">
                                <input
                                  id="email"
                                  name="email"
                                  type="email"
                                  value={formData.email}
                                  placeholder="Enter your email"
                                  onChange={handleInputChange}
                                />
                              </span>
                            </div>

                            <div className="col-md-6">
                              <label
                                className="left-align-label"
                                htmlFor="city"
                              >
                                City
                              </label>
                              <span className="text-input">
                                <input
                                  id="city"
                                  name="city"
                                  type="text"
                                  value={formData.city}
                                  placeholder="Enter your city"
                                  onChange={handleInputChange}
                                />
                              </span>
                            </div>

                            <div className="col-md-12">
                              <label
                                className="left-align-label"
                                htmlFor="notes"
                              >
                                Description
                              </label>
                              <span className="text-input">
                                <textarea
                                  id="notes"
                                  name="notes"
                                  rows="2"
                                  placeholder="Describe your problem..."
                                  value={formData.notes}
                                  onChange={handleInputChange}
                                ></textarea>
                              </span>
                            </div>

                            <div className="col-lg-12">
                              <div className="pt-15 mb_20 text-center">
                                <button
                                  className="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-fill ttm-btn-color-skincolor margin_top15"
                                  onClick={handleSubmit}
                                >
                                  Book Appointment
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </>
      )}
    </>
  );
}

export default Appointment;
